// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/detail/detail_cast.scss
// module id = 92
// module chunks = 0